module.exports = "/work-site/img/24houer_weather.accc17a3.png";